jQuery(function ($) {
    var hiddenButtons = $('.subnav__wrapper-link');
    var hidden = "-hidden";
    var notVisible = true;
    var menu = false;

    /**
     * Toggle the display of the search form inputs when button is clicked
     */

    if (window.innerWidth < 639 && !menu) {
        $('.subnav__wrapper').prepend('<a class="subnav__wrapper-menu-button" href="#">Show Menu</a>');
        menu = true;
        var searchFormToggle = $('.subnav__wrapper-menu-button');

        hiddenButtons.addClass(hidden);

        searchFormToggle.on('click', function (e) {
            e.preventDefault();

            if (notVisible) {
                notVisible = false;
                hiddenButtons.slideDown(200, 'linear', function () {
                    $(this).removeClass(hidden);
                    $('.subnav__wrapper-menu-button').text('Hide Menu');
                });
            } else if (!notVisible) {
                notVisible = true;
                hiddenButtons.slideUp(200, 'linear', function () {
                    $(this).addClass(hidden);
                    $('.subnav__wrapper-menu-button').text('Show Menu');
                });
            }

        });

    } else {
        $('.subnav__wrapper-menu-button').remove();
        menu = false;
    }

    /**
     * Display form and hide form visibility toggle on large screens
     */
    var resizeTimer;

    $(window).on('resize', function (e) {

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {

            if (window.innerWidth > 639) {
                hiddenButtons.removeClass(hidden);
                hiddenButtons.css('display', 'inline');
                $('.subnav__wrapper-menu-button').remove();
                menu = false;
            } else if (window.innerWidth < 639 && !menu) {
                $('.subnav__wrapper').prepend('<a class="subnav__wrapper-menu-button" href="#">Show Menu</a>');
                menu = true;
                hiddenButtons.addClass(hidden);
                var searchFormToggle = $('.subnav__wrapper-menu-button');

                searchFormToggle.on('click', function () {
                    e.preventDefault();

                    hiddenButtons.addClass(hidden);

                    if (notVisible) {
                        notVisible = false;
                        hiddenButtons.slideDown(200, 'linear', function () {
                            $(this).removeClass(hidden);
                            $('.subnav__wrapper-menu-button').text('Hide Menu');
                        });
                    } else if (!notVisible) {
                        notVisible = true;
                        hiddenButtons.slideUp(200, 'linear', function () {
                            $(this).addClass(hidden);
                            $('.subnav__wrapper-menu-button').text('Show Menu');
                        });
                    }

                });
            }

        }, 250);

    });
});